import { ClickAwayListener } from '@mui/material'
import Paper from '@mui/material/Paper'
import { AdminPackage } from '@returnmates/client-core/src/graphql/generated/api'
import { getPackages } from '@returnmates/client-core/src/selectors/packages'
import ExportToCSVIcon from '@returnmates/ui-core/src/components/imageComponents/ExportToCsvIcon'
import MoreIcon from '@returnmates/ui-core/src/components/imageComponents/MoreIcon'
import { unparse } from 'papaparse'
import { memo, useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import FilterCheckbox from '../../CheckboxFilter/FilterCheckbox'
import { consolidationsValue, unsortedValue } from '../constants'
import useStyles from '../styles'

interface Props {
  isHideConsolidationChecked: boolean
  isHideUnsortedChecked: boolean
  onHideConsolidationsSelect: () => void
  onHideUnsortedSelect: () => void
}

function MoreFilters({
  isHideConsolidationChecked,
  isHideUnsortedChecked,
  onHideConsolidationsSelect,
  onHideUnsortedSelect,
}: Props) {
  const packages = useSelector(getPackages)
  const classes = useStyles({})
  const [isOpenMoreFiltersPopup, setIsOpenMoreFiltersPopup] = useState(false)

  const handleClick = useCallback(() => {
    setIsOpenMoreFiltersPopup(prevIsOpenMoreFiltersPopup => !prevIsOpenMoreFiltersPopup)
  }, [])

  const exportToCSV = useCallback(() => {
    if (!packages?.length) {
      return null
    }

    const csv = unparse(packages as AdminPackage[])

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', 'packages.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }, [packages])

  return (
    <div className={classes.moreFiltersContainer}>
      <div className={classes.moreIconContainer} onClick={handleClick}>
        <MoreIcon />
      </div>
      {isOpenMoreFiltersPopup && (
        <ClickAwayListener onClickAway={handleClick}>
          <Paper className={classes.moreFiltersPopupContainer}>
            <div onClick={exportToCSV} className={classes.exportToCSVContainer}>
              <ExportToCSVIcon />
              <p className={classes.exportToCSV}>Export to CSV</p>
            </div>
            <FilterCheckbox
              isSelected={isHideConsolidationChecked}
              val={consolidationsValue}
              select={onHideConsolidationsSelect}
              className={classes.undersCheckbox}
            />
            <FilterCheckbox
              isSelected={isHideUnsortedChecked}
              val={unsortedValue}
              select={onHideUnsortedSelect}
              className={classes.undersCheckbox}
            />
          </Paper>
        </ClickAwayListener>
      )}
    </div>
  )
}

export default memo(MoreFilters)
